import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { collection, collectionData, Firestore, query, where } from '@angular/fire/firestore';
import { WindowRefService } from '../modules/share/services/window-ref.service';

export interface AgentType {
  _type: 'agent_type';
  id: string;
  callout: string;
  description: string;
  insuranceProducts: string;
  name: string;
  officeHeading: string;
  quoteUrl: {
    url: string;
    title: string;
  };
  weight: string;
}

@Injectable({
  providedIn: 'root',
})
export class AgentTypeService {
  private firestore = inject(Firestore);
  private windowRef = inject(WindowRefService);
  agentTypes$: Observable<AgentType[]>;

  constructor() {
    // this.agentTypesRef = this.afs
    //   .collection('wss-aaa-web')
    //   .doc(this.window.nativeWindow.metaData.clubId)
    //   .collection('data')
    //   .doc('drupal')
    //   .collection('terms', (ref) => {
    //     let query: firebase.firestore.CollectionReference | firebase.firestore.Query = ref;
    //     query = query.where('_type', '==', 'agentType');
    //     return query;
    //   });
    //
    // this.agentTypes$ = this.agentTypesRef.snapshotChanges().pipe(
    //   map((agentTypes: DocumentChangeAction<AgentType>[]) => {
    //     return agentTypes.map((result) => {
    //       if (result) {
    //         const data = result.payload.doc.data();
    //         data.id = result.payload.doc.id;
    //         return data;
    //       }
    //       return result;
    //     });
    //   }),
    // );
    // Todo: need to test
    const clubId = this.windowRef.clubId;
    const termsCollection = collection(this.firestore, `wss-aaa-web/${clubId}/data/drupal/terms`);
    const agentTypesQuery = query(termsCollection, where('_type', '==', 'agentType'));

    this.agentTypes$ = collectionData(agentTypesQuery, { idField: 'id' }) as Observable<AgentType[]>;
  }
}
